/**
 * 车辆状态实时面板
 */

import RealTimeSide from './RealTimeSide.vue';

export default RealTimeSide;